import React, { Component, useState, useEffect } from "react";
import { ACCESS_TOKEN } from "../../constants";
import { Redirect, useHistory } from "react-router-dom";
import { getUrlParameter } from "../../util/DataUtils";

function OAuth2RedirectHandler2({ props }) {
  const [token, setToken] = useState();
  const [error, setError] = useState();

  const searchParams = new URLSearchParams(window.location.search);

  const history = useHistory();
  const tokenQuery = searchParams.get("token");
  const errorQuery = searchParams.get("error");

  useEffect(() => {
    setToken(tokenQuery);
    setError(errorQuery);

    localStorage.setItem("accessToken", tokenQuery);

    if (tokenQuery) {
      history.go("/login-with-twitter-success");
    }
  }, [token, error]);

  return (
    <div>
      {searchParams.get("token") ? (
        <Redirect
          to={{
            pathname: "/login-with-twitter-success",
            state: {
              from: "/oauth2/redirect",
              accessToken: token,
            },
          }}
        />
      ) : (
        <Redirect
          to={{
            pathname: "/login",
            state: {
              from: "/oauth2/redirect",

              error: searchParams.get("error"),
            },
          }}
        />
      )}
    </div>
  );
}

export default OAuth2RedirectHandler2;



// WEBPACK FOOTER //
// ./src/user/oauth2/OAuth2RedirectHandler2.js